export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'software',
    name: '软件工具',
    description: '精选实用软件、效率工具、系统优化工具推荐与使用教程',
    icon: 'ri-tools-line',
    articleCount: 28,
  },
  {
    slug: 'tutorial',
    name: '学习教程',
    description: '编程开发、设计创作、语言学习等各类优质教程资源',
    icon: 'ri-book-open-line',
    articleCount: 35,
  },
  {
    slug: 'entertainment',
    name: '影视娱乐',
    description: '热门影视推荐、动漫追番指南、音乐资源分享',
    icon: 'ri-movie-2-line',
    articleCount: 42,
  },
  {
    slug: 'games',
    name: '游戏专区',
    description: '热门游戏攻略、新游评测、游戏资源与 mod 分享',
    icon: 'ri-gamepad-line',
    articleCount: 31,
  },
  {
    slug: 'resources',
    name: '资源下载',
    description: '优质模板素材、字体图标、PPT 模板等设计资源合集',
    icon: 'ri-download-cloud-2-line',
    articleCount: 26,
  },
  {
    slug: 'tech',
    name: '技术资讯',
    description: '前沿科技动态、互联网行业资讯、数码产品评测',
    icon: 'ri-cpu-line',
    articleCount: 38,
  },
];